import type { ReactNode } from 'react';

import type { TPodcastTranscriptElement } from '@shared/dream-components';
import { PodcastTranscriptElement } from '@shared/dream-components';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { PodcastShowEpisodePageLoaderData } from '~/routes/podcast/s/$showSlug/$episodeSlug';

interface Props {
  node: TPodcastTranscriptElement;
  children: ReactNode | ReactNode[];
}

const PodcastTranscript = ({ node, children }: Props) => {
  const { podcastEpisode } = useTypedLoaderData<PodcastShowEpisodePageLoaderData>();

  const transcript = podcastEpisode?.transcript;

  if (!Array.isArray(transcript) || transcript.length === 0) {
    return null;
  }

  const elementWithData: TPodcastTranscriptElement = {
    ...node,
    attrs: {
      ...node.attrs,
      data: { transcript },
    },
  };

  return (
    <div className="max-h-[800px] overflow-y-auto">
      <PodcastTranscriptElement element={elementWithData} isLive autoScroll={false}>
        {children}
      </PodcastTranscriptElement>
    </div>
  );
};

export default PodcastTranscript;
